const isValidUrl = urlString=> {
	try {
		return Boolean(new URL(urlString));
	}
	catch(e){
		return false;
	}
}

function tagsFilter() {
	let listEl = $('.widget-tags__list'),
		parentUrl = listEl.data('parent'),
		url = isValidUrl(parentUrl) ? new URL(parentUrl) : new URL(window.location.href),
		tagsList = [];

	$('.tag-filter').on('click', function(){
		let button = $(this),
			tag = button.data('tag');

		$(this).toggleClass('active');

		if(url.searchParams.get('tags')) {
			tagsList = url.searchParams.get('tags').split(',');
		}

		if( typeof tag !== 'undefined' && tag !== '') {
			if( !tagsList.includes(tag) ) {
				tagsList.push(tag);
			}
			else {
				let index = tagsList.indexOf(tag);
				if (index !== -1) {
					tagsList.splice(index, 1);
				}
			}
		}

		if(tagsList.length) {
			url.searchParams.set('tags', tagsList.join(','))
		}
		else {
			url.searchParams.delete('tags');
		}

		if( !$('body').hasClass('open-tags-filter') ) {
			if (window.location.href !== url.href) {
				window.location.href = url.href;
			}
		}
	});

	$('.widget-tags__apply').on('click', function(){
		if (window.location.href !== url.href) {
			window.location.href = url.href;
		}
	});

	$('.tags__reset').on('click', function(){
		let url = new URL(window.location.href);
		url.searchParams.delete('tags');
		if( window.location.href !== url.href ) {
			window.location.href = url.href;
		}
	});

	$('.filter-tags-toggle').on('click', function(){
		$('body').toggleClass('open-tags-filter')
	});
}

tagsFilter();
